import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import {
  BankSummaryGroup,
  BankSummaryGroupFun,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import { format } from "date-fns";

export default function BankSummary({
  bankName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { BankSummaryGroupdata } = useSelector((state) => state.BankSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(BankSummaryGroupFun());
    dispatch(
      BankSummaryGroup({
        Firm,
        Year: YearId,
        selectedIds: accountGroup.join(","),
        BankIDs: bankName.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [dispatch, Firm, YearId, accountGroup, bankName, startDate, endDate]);

  const getRows = BankSummaryGroupdata?.GroupDtl?.map((label, index) => ({
    // srNumber: index + 1,
    BankName: label.BankName,
    Opening: label.Opening,
    Receipts: label.Receipts,
    Payment: label.Payment,
    OpAmount: label.OpAmount,
    Closing: label.Closing,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Bank Name",
      key: "BankName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Opening", key: "Opening", align: "right", format: "true" },
    {
      label: "Total Receipt",
      key: "Receipts",
      align: "right",
      format: "true",
    },
    {
      label: "Total Payment",
      key: "Payment",
      align: "right",
      format: "true",
    },
    { label: "Closing", key: "Closing", align: "right", format: "true" },
  ];

  if (BankSummaryGroupdata === "no" || BankSummaryGroupdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            margin: 0,
            padding: "14px",
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            BANK SUMMARY
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
